import { Layout } from "common/Layout";
import dynamic from "next/dynamic";

const InstitutionsAboutSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsAboutSection/InstitutionsAboutSection"
    ),
  {
    ssr: false
  }
);
const InstituteTable = dynamic(
  () => import("common/Components/InstituteTable/InstituteTable"),
  {
    ssr: false
  }
);
const Featured = dynamic(
  () => import("common/Components/InstituteFinder/InstituteFinder"),
  {
    ssr: false
  }
);

const InstitutionsInformationSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsInformationSection/InstitutionsInformationSection"
    ),
  {
    ssr: false
  }
);

const InstitutionsProgramBox = dynamic(
  () =>
    import("common/Components/InstitutionsProgramBox/InstitutionsProgramBox"),
  {
    ssr: false
  }
);

const InstitutionsEligibleCriteriaSection = dynamic(
  () =>
    import(
      "common/Components/InstitutionsEligibleCriteriaSection/InstitutionsEligibleCriteriaSection"
    ),
  {
    ssr: false
  }
);
import { Institutes, ProgramNames } from "helpers/InstitutesData";
export const ItProgram = () => {
  return (
    <>
      <InstitutionsAboutSection
        name=""
        tag="Professional Year in Information Technology (IT)"
        about={[
          `The Professional Year in Information Technology program, developed by the Australian Computer Society (ACS), is designed to assist international graduates in the field of Information and Communications Technology (ICT) in acquiring practical skills and essential training. Regular counselling throughout the program is a crucial component in helping students gain extensive and practical knowledge.`,
          `Initiated by the Department of Home Affairs, this program aims to address the skill shortage in Australia. The program has a duration of 44 weeks, consisting of 32 weeks of theoretical knowledge and communication skills training, followed by a 12-week internship where students can apply their acquired knowledge and techniques in practical settings.`,
          `Upon successfully completing the program, students become eligible for an additional 5 points on the Department of Home Affairs points test, enhancing their prospects of obtaining permanent residency in Australia.`,
        ]}
        image="/assets/images/py-programs-1.webp"
        price={`A$8,000 to A$12,000`}
        duration="44 weeks (minimum) including 32 weeks training in-class and 12 weeks internship placement."
        location="Adelaide, Brisbane, Canberra, Darwin, Hobart, Melbourne, Sydney, Perth"
        industry="Information Technology"
        isProgram={true}
      />
      <InstituteTable />
      <Featured Institutes={Institutes} ProgramNames={ProgramNames} />
      <InstitutionsEligibleCriteriaSection
        eligibleCriteria={[
          `Candidates must have completed a recognized IT degree in Australia which provides at least 2 years of credit points.`,
          `A minimum score of 6 in IELTS English proficiency test with a minimum score of 6 across all bands OR a PTE score of 50 overall, with a minimum of 50 across all bands. `,
          `Candidates must hold or have applied for Visa 485 with 12 months of validity.`,
        ]}
      />
      <InstitutionsProgramBox />
      <InstitutionsInformationSection
        title2="Why Aussizz Group?"
        institutionsInformations={[
          {
            name: `Avail Scholarship through us`,
            icon: '/assets/Icons50/industryv1.webp',
          },
          {
            name: `We have enriched the lives of over 20,000 successful clients`,
            icon: '/assets/Icons50/Employee-Unwind-Session.webp',
          },
          {
            name: `Reward on referring a friend`,
            icon: '/assets/Icons50/studentv1.webp',
          },
          {
            name: `One FREE consultation`,
            icon: '/assets/Icons50/system.webp',
          },
          {
            name: `Free PTE Materials `,
            icon: '/assets/Icons50/system.webp',
          },
        ]}
      />

    </>
  );
};

ItProgram.getLayout = Layout;
ItProgram.layoutOptions = {
  pageTitle:
    "IT (Information Technology) - Professional Year Program | Australia | Aussizz Group",
  pageDescription:
    "IT PY Program is a 44-week program developed by the Australian Computer Society. It enables international graduates to enhance their skills in the Australian work environment.",
  pageKeywords:
    "Professional Year Program,py ,Professional Year ,IT program, 44-week program, Aussizz Group, Australia",
  imageUrl: "/assets/images/py-programs-1.webp"
};
